export default {"src":"/_next/static/media/patio.73c23bde.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};